<script>
  export let color = '#fff';
</script>

<svg 
      width="30" 
      height="30" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="No Description Available"
    >
      <defs>
        <mask id="noDescriptionMask">
          <rect width="24" height="24" fill="white" />
          <g transform="translate(0, 0)">
            <rect x="11" y="7" width="2" height="2" fill="black" rx="0.5" />
            <rect x="11" y="11" width="2" height="6" fill="black" rx="0.5" />
            <line x1="8" y1="8" x2="16" y2="16" stroke="black" strokeWidth="1.5" />
          </g>
        </mask>
      </defs>
      <circle 
        cx="12" 
        cy="12" 
        r="10" 
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeOpacity="0.2"
        mask="url(#noDescriptionMask)"
      />
    </svg>